import { getTime } from 'date-fns';
import { IPersistedQcRun } from './Interfaces';

export function getUpdatedElapsedTime(persistedQcRun: IPersistedQcRun): number {
    // update the elapsed time
    const now = getTime(Date.now());

    const delta = now - persistedQcRun.lastUpdatedTimestamp;
    let elapsedTime = persistedQcRun.elapsedTime;
    return elapsedTime + delta;
}
